// src/components/Sidebar.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
// 1. Import icons from lucide-react for consistency
import { Home, Users, Share2 } from 'lucide-react';

// Social Media Icons (Keep custom SVGs if you prefer, or switch to lucide icons like Linkedin, Instagram, Youtube)
const InstagramIcon = () => (<svg className="social-icon" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>);
const LinkedInIcon = () => (<svg className="social-icon" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect width="4" height="12" x="2" y="9"></rect><circle cx="4" cy="4" r="2"></circle></svg>);
const YouTubeIcon = () => (<svg className="social-icon" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>);

const Sidebar = ({ isOpen }) => {
  // 2. Update nav items to use Lucide components directly
  const navItems = [
    { name: 'Dashboard', path: '/', icon: <Home size={20} /> },
    { name: 'Referrals', path: '/referrals', icon: <Share2 size={20} /> }, // Share2 looks like a referral node icon
    { name: 'Users', path: '/users', icon: <Users size={20} /> }, 
  ];

  return (
    <aside className={`dashboard-sidebar ${isOpen ? 'open' : ''}`}>
      <nav className="sidebar-nav-container">
        <ul className="sidebar-nav">
          {navItems.map((item) => (
            <li key={item.name} className="nav-item">
              <NavLink 
                to={item.path} 
                end={item.path === '/'}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                {/* Render the icon component directly */}
                <span className="nav-icon-wrapper">{item.icon}</span>
                <span>{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <h4>Follow us</h4>
        <div className="social-links">
          <a href="https://www.instagram.com/ethanstech.co/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a>
          <a href="https://www.linkedin.com/company/ethans-tech/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon /></a>
          <a href="https://youtube.com/@ethanstechnologies?si=7FhBNFXgabdUbFxu" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><YouTubeIcon /></a>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;